import Alpine from 'alpinejs';

declare const window: Window & { Alpine?: typeof Alpine };

window.Alpine = Alpine;
Alpine.start();

import('./composables/usePostHog').then(({ usePostHog }) => usePostHog());

const loadDeferredScripts = (): void => {
    const bugsnagApiKey = import.meta.env.VITE_BUGSNAG_API_KEY;

    if (bugsnagApiKey) {
        import('@bugsnag/js').then(({ default: Bugsnag }) => {
            Bugsnag.start({
                apiKey: bugsnagApiKey,
                appVersion: '397',
                releaseStage: import.meta.env.VITE_APP_ENV || 'local',
            });
        });
    }
};

if (window.requestIdleCallback) {
    window.requestIdleCallback(loadDeferredScripts);
} else {
    window.setTimeout(loadDeferredScripts, 200);
}
